import { gql } from '@apollo/client';

export const DEALERS_BY_MARKET = gql`
  query DealersByMarket($market: String!) {
    dealersByMarket(market: $market) {
      dealers {
        name
        requestServiceEn
        requestServiceFr
        city
        region
      }
    }
  }
`;
